import StressData from "../GarminCards/StressData";
import CaloriesData from "../GarminCards/CaloriesData";
import BatteryData from "../GarminCards/BatteryData";
import HRVData from "../GarminCards/HRVData";
import SleepData from "../GarminCards/SleepData";
import StepData from "../GarminCards/StepData";
import HRData from "../GarminCards/HRData";
import RRData from "../GarminCards/RRData";
import POData from "../GarminCards/POData";

export default function Activities({ patientDetails }) {
  return (
    <div className="mt-3 h-80 scroll-m-1 scrollbar-thin scrollbar-thumb-blue-500 scrollbar-track-gray-200 overflow-y-scroll">
      <div className="grid grid-cols-2 gap-1 px-1">
        <div className="my-1 px-1">
          <HRData smartWatchId={patientDetails?.smartWatchUserId} />
        </div>
        <div className="my-1 px-1">
          <POData smartWatchId={patientDetails?.smartWatchUserId} />
        </div>
        <div className="my-1 px-1">
          <RRData smartWatchId={patientDetails?.smartWatchUserId} />
        </div>
        <div className="my-1 px-1">
          <HRVData smartWatchId={patientDetails?.smartWatchUserId} />
        </div>
        <div className="my-1 px-1">
          <StressData smartWatchId={patientDetails?.smartWatchUserId} />
        </div>

        <div className="my-1 px-1">
          <SleepData smartWatchId={patientDetails?.smartWatchUserId} />
        </div>

        <div className="my-1 px-1">
          <StepData smartWatchId={patientDetails?.smartWatchUserId} />
        </div>

        <div className="my-1 px-1">
          <CaloriesData smartWatchId={patientDetails?.smartWatchUserId} />
        </div>

        <div className="my-1 px-1">
          <BatteryData smartWatchId={patientDetails?.smartWatchUserId} />
        </div>
      </div>
    </div>
  );
}
